import FRCallback from './index.js';

/*
 * @forgerock/javascript-sdk
 *
 * recaptcha-callback.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/**
 * Represents a callback used to integrate reCAPTCHA.
 */
class ReCaptchaCallback extends FRCallback {
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the reCAPTCHA site key.
     */
    getSiteKey() {
        return this.getOutputByName('recaptchaSiteKey', '');
    }
    /**
     * Sets the reCAPTCHA result.
     */
    setResult(result) {
        this.setInputValue(result);
    }
}

export { ReCaptchaCallback as default };
